import React, { useState } from 'react';
import { FormGroup, ButtonContainer, SubmitButton } from '../../../form';
import { Button, Row, Col } from 'react-bootstrap';
import {
  InputText,
  InputNumber,
  InputColor,
  InputFile,
} from '../../../formikBindings';
import { useFormikContext, setNestedObjectValues, FormikTouched } from 'formik';
import { IThemeFormValues, IThemeFormProps } from './types';
import WelcomePagesTab from './WelcomePagesTab';
import DevicePreview from '../../../devicePreview';
import { VisitorLandingPage } from '../../../visitor/landingPage';
import styles from './ThemeForm.module.css';

const ThemeForm: React.FC<IThemeFormProps> = ({ createMode, onDelete }) => {
  const { values, errors, dirty, setTouched } =
    useFormikContext<IThemeFormValues>();

  const isNewOrDirty = (): boolean => dirty || !values.name;

  const images =
    values.welcomePages.map((welcomePage) => welcomePage.imageUrl) || [];

  const [selectedIndex, setSelectedIndex] = useState<number>(0);

  return (
    <div className="d-flex">
      <div className={styles.detailsColumn}>
        <FormGroup name="name" label="Name" required>
          <InputText name="name" maxLength={255} autoFocus />
        </FormGroup>
        <FormGroup name="logoUrl" label="Logo URL" required>
          {values.logoUrl && (
            <div className="mb-2">
              <img src={values.logoUrl} alt="Site Logo" />
            </div>
          )}
          <InputFile
            className="btn btn-info"
            name="logoUrl"
            url="/api/themes/logo"
          />
          <div className="invalid-feedback d-block">{errors['logoUrl']}</div>
          <small>
            <strong>Tip: </strong>Ideal size 48 x 140
          </small>
        </FormGroup>
        <FormGroup name="delayInSeconds" label="Delay (seconds)" required>
          <InputNumber name="delayInSeconds" />
        </FormGroup>
        <Row>
          <Col>
            <FormGroup
              name="signInButtonColor"
              label="Sign In Button Colour"
              required
            >
              <InputColor name="signInButtonColor" />
            </FormGroup>
          </Col>
          <Col>
            <FormGroup
              name="signInTextColor"
              label="Sign In Button Text Colour"
              required
            >
              <InputColor name="signInTextColor" />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col>
            <FormGroup
              name="signOutButtonColor"
              label="Sign Out Button Colour"
              required
            >
              <InputColor name="signOutButtonColor" />
            </FormGroup>
          </Col>
          <Col>
            <FormGroup
              name="signOutTextColor"
              label="Sign Out Button Text Colour"
              required
            >
              <InputColor name="signOutTextColor" />
            </FormGroup>
          </Col>
        </Row>

        <WelcomePagesTab
          images={images}
          selectedIndex={selectedIndex}
          onSelectedIndexChanged={(
            index: number,
            ignoreValidation?: boolean,
          ) => {
            if (!ignoreValidation && isNewOrDirty()) {
              const touched = setNestedObjectValues<
                FormikTouched<IThemeFormValues>
              >(values, true);

              setTouched(touched);

              if (Object.keys(errors).length !== 0) {
                return;
              }
            }

            setSelectedIndex(index);
          }}
        />
        <ButtonContainer>
          {!createMode && (
            <Button variant="danger" onClick={onDelete}>
              Delete
            </Button>
          )}
          <SubmitButton>Save</SubmitButton>
        </ButtonContainer>
      </div>
      <div className={styles.previewColumn}>
        <div className="px-3">
          <DevicePreview>
            <VisitorLandingPage
              pin="0000"
              siteTheme={values.welcomePages[selectedIndex]}
              site="London"
              signInButtonColor={values.signInButtonColor}
              signInTextColor={values.signInTextColor}
              signOutButtonColor={values.signOutButtonColor}
              signOutTextColor={values.signOutTextColor}
              logoUrl={values.logoUrl}
            />
          </DevicePreview>
        </div>
      </div>
    </div>
  );
};

export default ThemeForm;
